export const INDUSTRIES = [
  'Accounting',
  'Agriculture',
  'Automotive',
  'Banking',
  'Biotechnology',
  'Construction',
  'Consulting',
  'E-commerce',
  'Education',
  'Energy',
  'Entertainment',
  'Fashion',
  'Finance',
  'Food & Beverage',
  'Food Processing',
  'Healthcare',
  'Hospitality',
  'Information Technology',
  'Insurance',
  'Legal',
  'Manufacturing',
  'Marketing',
  'Media',
  'Pharmaceuticals',
  'Real Estate',
  'Retail',
  'Technology',
  'Telecommunications',
  'Transportation',
  'Travel & Tourism',
].sort();
